import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { faLink, faCheck } from '@fortawesome/pro-solid-svg-icons'
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TumblrShareButton,
  RedditShareButton,
  PinterestShareButton,
  FacebookIcon,
  TwitterIcon,
  PinterestIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  EmailShareButton,
  EmailIcon
} from 'react-share'

const SocialButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`

const ShareButton = styled.button.attrs({
  className: 'btn text-white text-uppercase fw-bold px-4 py-3 mb-3 btn-lg'
})``

const ContainerCentered = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

interface Props {
  url: string
  imageUrl: string
}

const View: React.FC<Props> = ({ url, imageUrl }) => {
  const [isCopied, setIsCopied] = React.useState(false)
  const [_, setTimeoutId] = React.useState<number | null>(null)

  const onCopy = React.useCallback(() => {
    setIsCopied(true)
    setTimeoutId(tId => {
      tId !== null && window.clearTimeout(tId)
      return window.setTimeout(() => {
        setIsCopied(false)
      }, 1000)
    })
  }, [])

  return (
    <>
      <ContainerCentered>
        <CopyToClipboard text={url} onCopy={onCopy}>
          <ShareButton>
            Link kopieren <FontAwesomeIcon icon={isCopied ? faCheck : faLink} className="ms-3" />
          </ShareButton>
        </CopyToClipboard>
      </ContainerCentered>

      <SocialButtons className="mt-3 mb-5">
        <FacebookShareButton url={url} hashtag="#indiaudio">
          <FacebookIcon size={48} round />
        </FacebookShareButton>
        <TwitterShareButton url={url} hashtags={['#indiaudio']}>
          <TwitterIcon size={48} round />
        </TwitterShareButton>
        <PinterestShareButton url={url} media={imageUrl}>
          <PinterestIcon size={48} round />
        </PinterestShareButton>
        <WhatsappShareButton url={url}>
          <WhatsappIcon size={48} round />
        </WhatsappShareButton>
        <RedditShareButton url={url}>
          <RedditIcon size={48} round />
        </RedditShareButton>
        <TumblrShareButton url={url}>
          <TumblrIcon size={48} round />
        </TumblrShareButton>
        <EmailShareButton url={url}>
          <EmailIcon size={48} round />
        </EmailShareButton>
      </SocialButtons>
    </>
  )
}

export default Object.assign(View, {})
